module.exports = __webpack_public_path__ + "static/media/billsgreen-new.42b96b41.svg";